import { Comment, Message, SavedMessage } from "../../../../models"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, StartFetchingAction, SuccessFetchingAction } from "../../../../utils/request-actions-helpers/createRequestActions"
import {GetSavedMessagesAdditionalData, getSavedMessagesActionTypes} from './actions/getSavedMessages';
import { postSavedMessageActionTypes, PostSavedMessageAdditionalData, saveMessageActionTypes, SaveMessageAdditionalData, UpdateLatestSavedMessageAction, UPDATE_LATEST_SAVED_MESSAGE } from "./actions";
import { isExistSavedMessage, withFilterSavedMessagesById, withUpdateSavedMessage } from "../../../../utils";
import { saveCommentActionTypes, SaveCommentAdditionalData } from "./actions/saveComment";
import { proccessSingleSavedMessageResponse } from "./actions/processSavedMessagesResponse";

export interface SavedMessageState {
    item: SavedMessage
    isDeleting: boolean
    deleteError?: FetchErrorInfo
}

export interface ChatSavedMessagesState {
    savedMessages: SavedMessageState[]
    isFetching: boolean
    isPosting: boolean
    isFetchingMore?: boolean
    savedMessagesPage?: number
    hasMoreSavedMessages?: boolean
    fetchError?: FetchErrorInfo
    postError?: FetchErrorInfo
}

export interface SavedMessagesState {
    data: {
        [userId: string]: ChatSavedMessagesState | undefined
    }
}

const initialMessagesState: ChatSavedMessagesState = {
    savedMessages: [],
    isFetching: false,
    isPosting: false,
    isFetchingMore: false,
    savedMessagesPage: 0,
    hasMoreSavedMessages: false
}

export const initialSavedMessagesState: SavedMessagesState = {
    data: {}
}
type SavedMessagesAdditionalData = GetSavedMessagesAdditionalData | UpdateLatestSavedMessageAction

export const savedMessagesReducer = (state: SavedMessagesState = initialSavedMessagesState, action: FetchRequestActions<SavedMessage[], SavedMessagesAdditionalData>): SavedMessagesState => {
    switch (action.type) {
        case UPDATE_LATEST_SAVED_MESSAGE: {
            const latestCommentAction = action as UpdateLatestSavedMessageAction;

            const {userId, message} = latestCommentAction
            const documentComments = (state.data[userId] || { ...initialMessagesState })

            const prevMessages = documentComments.savedMessages;
            const id = message.messageType === 0 ? message.comment?.commentId as string : message.message?.id as number
            const existMessage = isExistSavedMessage(message.messageType, id, prevMessages);

            if(existMessage){
                return state;
            }

            const messageState: SavedMessageState = {
                item: message,
                isDeleting: false
            }
            
            let newData: ChatSavedMessagesState = {
                ...documentComments,
                savedMessages:  [messageState, ...documentComments.savedMessages]
            }

            const newState: SavedMessagesState = {
                data: {
                    ...state.data,
                    [userId]: newData
                }
            }
            return newState 

        }
        case getSavedMessagesActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetSavedMessagesAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
            const newState: SavedMessagesState = {
                data: {
                    ...state.data
                }
            }
            const {userId, messagesPage} = startFetchingAction.additionalData
            const documentCommmentsState = state.data[userId] || { ...initialMessagesState }
            newState.data[userId] = {
                ...documentCommmentsState,
                isFetching: messagesPage as number === 0,
                isFetchingMore: messagesPage as number > 0 
            }

            return newState   
        }
        case getSavedMessagesActionTypes.success: {
            const successAction = action as SuccessFetchingAction<SavedMessage[], GetSavedMessagesAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {userId, messagesPage} = successAction.additionalData
            const documentMessages = (state.data[userId] || { ...initialMessagesState })
            
            const resultMessages = successAction.result.map(x => {
                const messageState: SavedMessageState = {
                    item: x,
                    isDeleting: false
                }
                return messageState
            }).sort((resA, resB) => {
                return new Date(resB.item.dateTime).getTime() - new Date(resA.item.dateTime).getTime()
            });
            const newMessages =  withFilterSavedMessagesById([ ...resultMessages,...documentMessages.savedMessages,]);

            let newData: ChatSavedMessagesState = {
                ...documentMessages,
                isFetching: false,
                isFetchingMore: false,
                hasMoreSavedMessages:  resultMessages.length > 0,
                savedMessagesPage: messagesPage,
                savedMessages:  messagesPage as number > 0 ? newMessages : resultMessages
            }

            const newState: SavedMessagesState = {
                data: {
                    ...state.data,
                    [userId]: newData
                }
            }
            return newState 
        }
        case getSavedMessagesActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetSavedMessagesAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { userId } = errorAction.additionalData
            const documentMessages = state.data[userId] || { ...initialMessagesState }
            const newState: SavedMessagesState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.userId]: {
                        ...documentMessages,
                        isFetching: false,
                        savedMessages: [],
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case postSavedMessageActionTypes.start: {
            const postAction = action as StartFetchingAction<PostSavedMessageAdditionalData>
            if (!postAction.additionalData) {
                return state
            }
            const { chatUId } = postAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: true
                    }
                }
            }
        }
        case postSavedMessageActionTypes.success: {
            const successPosting = action as SuccessFetchingAction<Message, PostSavedMessageAdditionalData>
            if (!successPosting.additionalData) {
                return state
            }

            const { chatUId } = successPosting.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            const prevMessages = documentMessages.savedMessages;
            const existMessage = isExistSavedMessage(2, successPosting.result.id, prevMessages);
            
            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        savedMessages: existMessage ? [...withUpdateSavedMessage(prevMessages, {message: successPosting.result, messageType: 2, dateTime: successPosting.result.creationDateTime, comment: null})] : [
                            ...documentMessages.savedMessages,
                            { item: {message: successPosting.result, messageType: 2, dateTime: successPosting.result.creationDateTime, comment: null}, isDeleting: false }
                        ]
                    }
                }
            }
        }
        case postSavedMessageActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<PostSavedMessageAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        postError: errorAction.error
                    }
                }
            }
        }
        case saveCommentActionTypes.start: {
            const postAction = action as StartFetchingAction<SaveCommentAdditionalData>
            if (!postAction.additionalData) {
                return state
            }
            const { chatUId } = postAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: true
                    }
                }
            }
        }
        case saveCommentActionTypes.success: {
            const successPosting = action as SuccessFetchingAction<any, SaveCommentAdditionalData>
            if (!successPosting.additionalData) {
                return state
            }
            
            const { chatUId } = successPosting.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            const item = proccessSingleSavedMessageResponse(successPosting.result)            
            const savedMessages = Object.keys(item).length > 0 ? [...documentMessages.savedMessages, {item, isDeleting: false}] : documentMessages.savedMessages

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        savedMessages,
                        isPosting: false,
                    }
                }
            }
        }
        case saveCommentActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<SaveCommentAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        postError: errorAction.error
                    }
                }
            }
        }
        case saveMessageActionTypes.start: {
            const postAction = action as StartFetchingAction<SaveMessageAdditionalData>
            if (!postAction.additionalData) {
                return state
            }
            const { chatUId } = postAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: true
                    }
                }
            }
        }
        case saveMessageActionTypes.success: {
            const successPosting = action as SuccessFetchingAction<any, SaveMessageAdditionalData>
            if (!successPosting.additionalData) {
                return state
            }

            const { chatUId } = successPosting.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }
            
            const item = proccessSingleSavedMessageResponse(successPosting.result)            
            const savedMessages = Object.keys(item).length > 0 ? [...documentMessages.savedMessages, {item, isDeleting: false}] : documentMessages.savedMessages
            
            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        savedMessages,
                        isPosting: false,
                    }
                }
            }
        }
        case saveMessageActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<SaveMessageAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        postError: errorAction.error
                    }
                }
            }
        }
        default:
            return state
    }
}